import { DashboardPaths, HomePaths } from '@/core/constants';
import { Role } from '@/core/security/Role';
import { ApiPermissions } from '@/core/security/Permissions';

export interface INavigationItem {
	name: string;
	icon?: string;
	link?: string | null;
	auth?: boolean;
	roles?: Role[];
	permissions?: string[];
	children?: INavigationItem[];
}

export const navigationItems = [
    {
        name: 'Home',
        icon: 'cube-outline',
        link: DashboardPaths.Home
    },
    {
        name: 'News',
        icon: 'newspaper-variant-multiple',
        link: DashboardPaths.News,
        permissions: Object.values(ApiPermissions.News)
    },
    {
        name: 'Users',
        icon: 'account',
        link: DashboardPaths.Users,
        permissions: Object.values(ApiPermissions.User)
    },
    {
        name: 'Sliders',
        icon: 'image-area',
        link: DashboardPaths.Slider,
        permissions: Object.values(ApiPermissions.Slider)
    },
    {
        name: 'Toasts',
        icon: 'bell-ring',
        link: DashboardPaths.Toast,
        permissions: Object.values(ApiPermissions.Toast)
    },
    {
        name: 'Changelogs',
        icon: 'checkbox-marked-outline',
        link: DashboardPaths.Changelog,
        permissions: Object.values(ApiPermissions.Changelog)
    },
    {
        name: 'Content Pages',
        icon: 'pencil',
        link: DashboardPaths.Content
        // permissions: Object.values(ApiPermissions.Content)
    },
    {
        name: 'Metrics',
        icon: 'gauge',
        link: DashboardPaths.Metrics
    },
    {
        name: 'Realm Settings',
        icon: 'security',
        link: DashboardPaths.Realm,
        permissions: Object.values(ApiPermissions.Realm)
    },
    {
        name: 'Realms',
        icon: 'server-security',
        link: DashboardPaths.Realms,
        roles: [Role.SuperAdmin]
    },
    {
        name: 'LUA Workspace',
        icon: 'language-lua',
        link: DashboardPaths.LuaWorkspace,
        roles: [Role.Administrator],
        permissions: Object.values(ApiPermissions.Realm)
    },
    {
        name: 'Core Workspace',
        icon: 'language-cpp',
        link: DashboardPaths.CoreWorkspace,
        roles: [Role.Administrator],
        permissions: [ApiPermissions.Realm.GetCoreFiles]
    },
    {
        name: 'Modules',
        icon: 'plus-circle',
        link: DashboardPaths.Modules,
        roles: [Role.Administrator],
        permissions: [ApiPermissions.Realm.Modules]
    },
    {
        name: 'Worldserver.conf',
        icon: 'cog',
        link: DashboardPaths.WorldServerConf,
        roles: [Role.Administrator],
        permissions: [ApiPermissions.Realm.WorldServerConfig]
    }
];

export const topNavigationItems: INavigationItem[] = [
    {
        name: 'News',
        icon: 'newspaper-variant-multiple',
        auth: true,
        link: HomePaths.News
    },
    {
        name: 'How To Connect',
        icon: 'wifi',
        link: HomePaths.Connect
    },
    {
        name: 'Armory',
        icon: 'mine',
        link: HomePaths.Armory
    },
    {
        name: 'online players',
        icon: 'earth',
        link: HomePaths.OnlinePlayers
    },
    {
        name: 'PvP Statistics',
        icon: 'sword-cross',
        link: HomePaths.PvPStatistics
    },
    {
        name: 'changelog',
        icon: 'clipboard-check',
        link: HomePaths.Changelog
    },
    {
        name: 'bugtracker',
        icon: 'bug-check',
        link: HomePaths.BugTracker
    }
];
